<section class="resultado" *ngIf="carregando || erro || resultado">
  <header>
    <div>
      <h5>Resultado da campanha</h5>
      <p *ngIf="resultado">Quem recebeu e fez pedido em até {{ resultado.janelaDias }} dias depois do envio.</p>
    </div>
  </header>

  <p class="estado" *ngIf="carregando"><i class="fe-loader"></i>Calculando…</p>
  <p class="estado erro" *ngIf="erro">{{ erro }}</p>

  <ng-container *ngIf="resultado && !carregando">
    <div class="kpis">
      <div class="kpi destaque">
        <span>Receita gerada</span>
        <strong>{{ moeda(resultado.receita) }}</strong>
        <small>{{ resultado.pedidos }} {{ resultado.pedidos === 1 ? 'pedido' : 'pedidos' }}</small>
      </div>
      <div class="kpi">
        <span>Clientes que pediram</span>
        <strong>{{ resultado.clientesQuePediram }}</strong>
        <small>de {{ resultado.enviadas }} que receberam</small>
      </div>
      <div class="kpi">
        <span>Conversão</span>
        <strong>{{ percentual(resultado.taxaConversao) }}</strong>
        <small>pediram depois da mensagem</small>
      </div>
    </div>

    <div class="origens" *ngIf="resultado.receita > 0">
      <div class="barra">
        <span *ngFor="let o of origens" [style.width.%]="o.parte" [style.background]="o.cor" [title]="o.nome"></span>
      </div>
      <div class="legenda">
        <div *ngFor="let o of origens">
          <i [style.background]="o.cor"></i>
          <b>{{ o.nome }}</b>
          <span>{{ o.clientes }} {{ o.clientes === 1 ? 'cliente' : 'clientes' }} · {{ moeda(o.receita) }}</span>
        </div>
      </div>
      <p class="nota"><b>Recuperado</b> estava parado além do corte de Sumido quando recebeu: é o dinheiro que dificilmente viria sozinho.</p>
    </div>

    <p class="vazio" *ngIf="!resultado.conversoes.length">
      Ninguém que recebeu pediu ainda. O resultado se atualiza sozinho durante os {{ resultado.janelaDias }} dias depois do envio.
    </p>

    <ul class="conversoes" *ngIf="resultado.conversoes.length">
      <li *ngFor="let c of conversoesVisiveis">
        <a [routerLink]="['/admin/contatos', c.telefone]">
          <strong>{{ c.nome || telefone(c.telefone) }}</strong>
          <small>{{ telefone(c.telefone) }}<ng-container *ngIf="c.diasParado !== null"> · estava há {{ c.diasParado }} dias sem pedir</ng-container></small>
        </a>
        <span class="tipo" [style.color]="tipo(c.tipo).cor" [style.background]="tipo(c.tipo).fundo">{{ tipo(c.tipo).nome }}</span>
        <span class="valor">{{ moeda(c.receita) }}</span>
      </li>
    </ul>
    <button type="button" class="ver-todos" *ngIf="resultado.conversoes.length > 8" (click)="verTodos = !verTodos">
      {{ verTodos ? 'Mostrar menos' : 'Ver todos os ' + resultado.conversoes.length }}
    </button>
  </ng-container>
</section>
